"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBBaseTag = _interopRequireDefault(require("../HBBaseTag/HBBaseTag"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var colorMap = {
  orange: '#FFE7CC',
  yellow: '#FFF1CF',
  red: '#FAE1E1',
  green: '#E1F2D9',
  'light blue': '#E4F7F6',
  blue: '#DFE8FF',
  purple: '#EFDEFF',
  pink: '#FFE8FA',
  brown: '#EDE1D9',
  grey: '#EBEBEB'
};
var HBMemberTag = function HBMemberTag(props) {
  var label = props.label,
    _props$color = props.color,
    color = _props$color === void 0 ? 'orange' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size;
  var baseProps = _objectSpread({
    label: label,
    size: size,
    isSelected: false,
    isSquare: true,
    padding: size === 'sm' ? '0 6px' : '0 8px',
    theme: {
      backgroundColor: colorMap[color],
      labelColor: 'textPrimary',
      editIconColor: 'neutral800',
      removeIconColor: 'neutral800'
    }
  }, props);
  return /*#__PURE__*/_react["default"].createElement(HBMemberTagWrapper, baseProps);
};
var _default = exports["default"] = HBMemberTag;
var HBMemberTagWrapper = (0, _styledComponents["default"])(_HBBaseTag["default"]).withConfig({
  displayName: "HBMemberTag__HBMemberTagWrapper",
  componentId: "sc-i72fhh-0"
})([""]);
//# sourceMappingURL=HBMemberTag.js.map